Ext.define('SA.data.mixin.ManyAttributes', {
    addAttribute(attribute) {
        attribute = SA.data.AttributesCache.getId(attribute);

        if (this.containsAttribute(attribute)) {
            return null;
        }

        if (this.addAttributeImpl(attribute) === false) {
            return false;
        }

        this.fireEvent('change:attribute', this);

        return true;
    },

    addAttributeImpl(attribute) {
        this.setAttributesImpl(this.getAttributes().concat(attribute));
    },

    addAttributes(attributes) {
        attributes.forEach(this.addAttribute, this);
    },

    addAttributesAfter({after: afterAttribute, attributes: newAttributes}) {
        var attributes = this.getAttributes().slice(),
            index = attributes.indexOf(afterAttribute) + 1,
            newAttributes = newAttributes.filter(attribute => !this.containsAttribute(attribute));

        this.addAttributes(newAttributes);
        this.setAttributes(Ext.Array.insert(attributes, index, newAttributes));
    },

    containsAttribute(attribute) {
        return this.getAttributes().includes(attribute);
    },

    getAttributes() {
        return this.data.attributes;
    },

    hasAttributes() {
        return this.getAttributes().length > 0;
    },

    moveAttribute(oldIndex, newIndex) {
        var attributes = this.getAttributes();

        if (typeof oldIndex !== 'number') {
            oldIndex = attributes.indexOf(oldIndex);
        }



                newIndex = Ext.Number.constrain(newIndex, 0, attributes.length - 1);

        if (oldIndex === newIndex) {
            return;
        }

        this.moveAttributeImpl(oldIndex, newIndex);

        this.fireEvent('change:attribute');
    },

    moveAttributeImpl(oldIndex, newIndex) {
        var attributes = this.getAttributes().slice();

        attributes.splice(newIndex, 0, attributes.splice(oldIndex, 1)[0]);

        this.setAttributesImpl(attributes);
    },

    removeAttribute(attribute) {
        attribute = SA.data.AttributesCache.getId(attribute);

        if (this.containsAttribute(attribute)) {
            this.removeAttributeImpl(attribute);

            this.fireEvent('change:attribute', this);
        }
    },

    removeAttributeImpl(attribute) {
        var attributes = this.getAttributes().slice(),
            index = attributes.indexOf(attribute);

        attributes.splice(index, 1);

        this.setAttributesImpl(attributes);
    },

    setAttributes(attributes) {
        this.setAttributesImpl(SA.data.AttributesCache.getIds(attributes));

        this.fireEvent('change:attribute', this);
    },

    setAttributesImpl(attributes) {
        this.data.attributes = attributes;
    },

    sortAttributes(fn) {
        var attributes = this.getAttributes().slice();

        attributes.sort(fn);

        this.setAttributes(attributes);
    },

    toggleAttribute(attribute, toggle) {
        toggle ? this.addAttribute(attribute) : this.removeAttribute(attribute);
    }
});